import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import moment from "moment";

function Pelaporan() {
    const navigate = useNavigate();

    //define state
    const [Pelaporan, setPelaporan] = useState([]);

    //function "fetchData"
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // fetching
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pelaporan/readPelaporan`
            );
            // get response data
            const data = response.data;
            // assign response data to state "Customer"
            setPelaporan(data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error, e.g., show a Pelaporan-friendly message
        }
    };

    useEffect(() => {
        //panggil method "fetchData"
        fetchData();
    }, []);

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Make axios delete request
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/pelaporan/deletePelaporan/${id}`
                    );

                    // Refetch data after successful delete
                    fetchData();

                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Foto Banner",
            width: "120px",
            selector: (row) => (
                <img
                    src={
                        row.foto_cover.startsWith("http")
                            ? row.foto_cover
                            : `${process.env.REACT_APP_API_URL}/pelaporan/uploads/${row.foto_cover}`
                    }
                    alt="Pelaporan"
                    style={{ width: " 100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Foto Wbs",
            width: "120px",
            selector: (row) => (
                <img
                    src={
                        row.foto_wbs.startsWith("http")
                            ? row.foto_wbs
                            : `${process.env.REACT_APP_API_URL}/pelaporan/uploads/${row.foto_wbs}`
                    }
                    alt="Pelaporan"
                    style={{ width: " 100px", height: "70px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Deskripsi",
            width: "70px",
            selector: (row) => row.deskripsi,
            sortable: true,
        },
        {
            name: "Dokumen",
            selector: (row) => (
                <a href={row.dokumen} target="_blank" rel="noopener noreferrer">
                    Lihat Dokumen
                </a>
            ),
            sortable: true,
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/pelaporanEdit/${row.id}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button onClick={() => handleDelete(row.id)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Pelaporan</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Pelaporan</h3>
                                    </div>
                                    <div className="card-body">
                                        {Pelaporan.length === 0 && (
                                            <Link to="/pelaporanAdd" className="btn btn-primary">
                                                <i className="nav-icon fas fa-plus mr-2" />
                                                Add Data
                                            </Link>
                                        )}
                                        <DataTable columns={columns} data={Pelaporan} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Pelaporan;
